import styled from '@emotion/styled';
import strings from '@i18n/index';

type EmptySearchResultProps = {
  message?: string;
  marginTop?: string;
};

const EmptySearchResult = ({ message = strings.SEARCH__NO_RESULT, marginTop }: EmptySearchResultProps) => {
  return (
    <Container marginTop={marginTop}>
      <Text>{message}</Text>
    </Container>
  );
};

export default EmptySearchResult;

const Container = styled.div<{ marginTop?: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: ${({ marginTop }) => marginTop && marginTop};
`;

const Text = styled.div`
  color: ${({ theme }) => theme.colors.neutral[400]};
  text-align: center;
  font-size: 16px;
  line-height: 20px;
`;
